import React, { Fragment, useState } from "react";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { connect } from "react-redux";
import { setAlert } from "../../../actions/alert";
import PropTypes from "prop-types";

import RedLogo from "../Mentors/RedLogo";
import RedSpinner from "../../../img/Red_Spinner.gif";

import Alert from "./Alert";

let formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const CardField = ({ onChange }) => (
  <div className="FormRow">
    <CardElement
      className="sub-input"
      onChange={onChange}
      options={CARD_OPTIONS}
    />
  </div>
);

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#FFF",
      color: "#fff",
      fontWeight: 500,
      fontFamily: "Krub, sans-serif",
      fontSize: "14px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#FFF",
      },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "#ffc7ee",
    },
  },
};

const Field = ({
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <input
      className="sub-input"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const SubmitButton = ({ processing, error, children, disabled }) => (
  <button
    className={`purchase-sub background-red bold ${
      error ? "SubmitButton--error" : ""
    }`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? "Processing..." : children}
  </button>
);

const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage white" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);

const GiftCommunitySubscriptions = ({
  setshowGiftSubscriptions,
  profile: {
    role,
    _id,
    channelid,
    avatar,
    firstname,
    lastname,
    location,
    jobtitle,
  },
  user,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardComplete, setCardComplete] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [billingDetails, setBillingDetails] = useState({
    name: "",
    email: "",
    address: {
      country: "US",
      city: "",
      line1: "",
      line2: "",
      state: "Alabama",
    },
  });
  const [paymentDetails, setPaymentDetails] = useState({
    status: "",
    amount_received: 0,
    receipt_email: "",
    current_subscriber: {
      msg: "",
    },
  });
  const [isGiftAnon, setGiftAnon] = useState(false);
  const [showPayment, setshowPayment] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState({
    price: 0,
    subs: 0,
    customSubs: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (billingDetails.name === "") {
      setAlert("Please enter a name");
    }

    if (billingDetails.email === "") {
      setAlert("Please enter a valid email");
    }

    if (billingDetails.address.line1 === "") {
      setAlert("Please enter your street address");
    }

    if (billingDetails.address.city === "") {
      setAlert("Please enter a city");
    }

    if (billingDetails.address.state === "") {
      setAlert("Please enter a state");
    }

    if (billingDetails.address.country === "") {
      setAlert("Please enter a country");
    }

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: billingDetails,
    });

    setProcessing(false);

    if (error) {
      setError(error);
    } else {
      setPaymentMethod(paymentMethod);
    }

    try {
      const { id } = paymentMethod;
      const res = await axios.post("http://localhost:5000/giftcommunitysubs", {
        id,
        _id,
        billingDetails,
        isGiftAnon,
        selectedPlan,
      });

      setPaymentDetails({
        status: res.data.status,
        amount_received: res.data.amount_received,
        receipt_email: res.data.receipt_email,
        current_subscriber: { msg: res.data.msg },
      });
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <Fragment>
      {
        <div>
          {paymentDetails.status === "succeeded" && showPayment && (
            <div className="subscription-overlay">
              <div className="subscription-box-confirmation">
                <i
                  className="far fa-times-circle red fa-3x subscription-x"
                  onClick={() => {
                    setshowPayment(false);
                    setshowGiftSubscriptions(false);
                  }}
                ></i>
                <div className="subscription-type-container">
                  <p className="nav-logo">
                    <RedLogo />
                  </p>
                  <h1 className="subscription-name red">Payment Successful!</h1>
                </div>
                <div className="sub-grid-three-alt">
                  <div className="subscription-user">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                        <p className="sub-section red">
                          Subscriptions gifted to:
                        </p>
                      </div>
                    </div>
                    <div className="sub-user">
                      <div className="online-avi-container">
                        <div className="avi-color-border-alt red">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                            className="sub-avi"
                            alt="avi"
                          />
                        </div>
                      </div>
                      <div className="sub-info">
                        <ul className="user-online-items">
                          <li className="user-online-item">
                            <span className="red name-font bold">
                              {firstname} {lastname}
                            </span>
                          </li>
                          <li className="user-online-item">{jobtitle}</li>
                          <li className="user-online-item">
                            {location.state}, {location.country}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="subscription-user">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                        <p className="sub-section red">
                          Subscriptions gifted from:
                        </p>
                      </div>
                    </div>
                    <div className="sub-user">
                      <div className="online-avi-container">
                        <div
                          className={`avi-color-border-alt ${
                            user.role === "innovator" ? "green" : "red"
                          }`}
                        >
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                            className="sub-avi"
                            alt="avi-two"
                          />
                        </div>
                      </div>
                      <div className="sub-info">
                        <ul className="user-online-items">
                          <li className="user-online-item">
                            <span
                              className={`${
                                user.role === "innovator" ? "green" : "red"
                              } name-font bold`}
                            >
                              {user.firstname} {user.lastname}
                            </span>
                          </li>
                          <li className="user-online-item">{user.jobtitle}</li>
                          <li className="user-online-item">
                            {user.location.city}, {user.location.state}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="sub-container">
                    <div className="sub-section-container">
                      <div className="flex-only">
                        <p className="sub-section red">Subtotal</p>
                      </div>
                    </div>
                    <div className="subtotal">
                      <p className="total-price white">
                        {`$${paymentDetails.amount_received * 0.01}.00`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="sub-grid">
                  <p className="user-request-text">
                    Thank you for your payment! A receipt has been emailed to
                    the following email address:{" "}
                    <span className="red bold">
                      {paymentDetails.receipt_email}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}
          {!paymentMethod && paymentDetails.status !== "succeeded" && (
            <div className="subscription-overlay">
              <div className="subscription-box">
                {processing && (
                  <div className="spinner-overlay">
                    <img src={RedSpinner} alt="spinner-position" />
                  </div>
                )}
                <i
                  className="far fa-times-circle red fa-3x subscription-x"
                  onClick={() => setshowGiftSubscriptions(false)}
                ></i>
                <div className="subscription-type-container">
                  <p className="nav-logo">
                    <RedLogo />
                  </p>
                  <h1 className="subscription-name red">
                    Gift subscriptions to the {channelid} community
                  </h1>
                </div>
                <div className="subscription-overflow">
                  <form
                    method="POST"
                    className="subscription-box-container"
                    id="red-scroll"
                    onSubmit={(e) => handleSubmit(e)}
                  >
                    <div className="sub-grid-three-alt">
                      <div className="subscription-user">
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">
                              Subscriptions gifted to:
                            </p>
                          </div>
                        </div>
                        <div className="sub-user">
                          <div className="online-avi-container">
                            <div className="avi-color-border-alt red">
                              <img
                                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                                className="sub-avi"
                                alt="avi"
                              />
                            </div>
                          </div>
                          <div className="sub-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span className="red name-font bold">
                                  {firstname} {lastname}
                                </span>
                              </li>
                              <li className="user-online-item">{jobtitle}</li>
                              <li className="user-online-item">
                                {location.state}, {location.country}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="subscription-user">
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">
                              Subscriptions gifted from:
                            </p>
                          </div>
                        </div>
                        <div className="sub-user">
                          <div className="online-avi-container">
                            <div
                              className={`avi-color-border-alt ${
                                user.role === "mentor" ? "red" : "green"
                              }`}
                            >
                              <img
                                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                                className="sub-avi"
                                alt="avi-two"
                              />
                            </div>
                          </div>
                          <div className="sub-info">
                            <ul className="user-online-items">
                              <li className="user-online-item">
                                <span
                                  className={`${
                                    user.role === "innovator" ? "green" : "red"
                                  } name-font bold`}
                                >
                                  {user.firstname} {user.lastname}
                                </span>
                              </li>
                              <li className="user-online-item">
                                {user.jobtitle}
                              </li>
                              <li className="user-online-item">
                                {user.location.city}, {user.location.state}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {selectedPlan.customSubs ? (
                        <div className="sub-container">
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <p className="sub-section red">Subtotal</p>
                            </div>
                          </div>
                          <div className="subtotal">
                            <p className="total-price white">
                              {formatter.format(selectedPlan.subs * 5)}
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="sub-container">
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <p className="sub-section red">Subtotal</p>
                            </div>
                          </div>
                          <div className="subtotal">
                            <p className="total-price white">
                              {formatter.format(selectedPlan.price)}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    {selectedPlan.subs !== 0 && (
                      <div
                        className="select-plan red bold"
                        onClick={() =>
                          setSelectedPlan({
                            price: 0,
                            subs: 0,
                            customSubs: false,
                          })
                        }
                      >
                        Select a different plan
                      </div>
                    )}
                    {selectedPlan.price !== "0" &&
                      selectedPlan.subs === "5" &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">Gift 5 Subs</p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={25}
                            subs={5}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">5</div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">5</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $25
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {selectedPlan.price === 0 && selectedPlan.subs === 0 && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">Gift 5 Subs</p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={25}
                          subs={5}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                            })
                          }
                        >
                          <div className="gift-subs-count white bold">5</div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">5</span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              $25
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.price !== "0" &&
                      selectedPlan.subs === "10" &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">Gift 10 Subs</p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={50}
                            subs={10}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">10</div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">10</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $50
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {selectedPlan.price === 0 && selectedPlan.subs === 0 && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">Gift 10 Subs</p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={50}
                          subs={10}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                            })
                          }
                        >
                          <div className="gift-subs-count white bold">10</div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">10</span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              $50
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.price !== "0" &&
                      selectedPlan.subs === "25" &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">Gift 25 Subs</p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={125}
                            subs={25}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">25</div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">25</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $125
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {selectedPlan.price === 0 && selectedPlan.subs === 0 && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">Gift 25 Subs</p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={125}
                          subs={25}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                            })
                          }
                        >
                          <div className="gift-subs-count white bold">25</div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">25</span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              $125
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.price !== "0" &&
                      selectedPlan.subs === "50" &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">Gift 50 Subs</p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={250}
                            subs={50}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">50</div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">50</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $250
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {selectedPlan.price === 0 && selectedPlan.subs === 0 && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">Gift 50 Subs</p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={250}
                          subs={50}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                            })
                          }
                        >
                          <div className="gift-subs-count white bold">50</div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">50</span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              $250
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.price !== "0" &&
                      selectedPlan.subs === "100" &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">Gift 100 Subs</p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={500}
                            subs={100}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">
                              100
                            </div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">100</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $500
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {selectedPlan.price === 0 && selectedPlan.subs === 0 && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">Gift 100 Subs</p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={500}
                          subs={100}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                            })
                          }
                        >
                          <div className="gift-subs-count white bold">100</div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">100</span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              $500
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.customSubs && (
                      <div>
                        <div className="sub-section-container">
                          <div className="flex-only">
                            <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                            <p className="sub-section red">
                              Gift Custom number of Subs (Limit 100 max)
                            </p>
                          </div>
                        </div>
                        <div
                          className="gift-subs"
                          price={0}
                          subs={0}
                          onClick={(e) =>
                            setSelectedPlan({
                              price: e.currentTarget.attributes.price.value,
                              subs: e.currentTarget.attributes.subs.value,
                              customSubs: true,
                            })
                          }
                        >
                          <div className="gift-subs-count-custom white bold">
                            <input
                              className="number-input bold"
                              value={selectedPlan.subs}
                              type="number"
                              name="customsubs"
                              onChange={(e) => {
                                const numberRegex = new RegExp(
                                  "^[1-9][0-9]?$|^100$"
                                );
                                e.target.value <= 100 &&
                                  setSelectedPlan({
                                    price: e.target.value * 5,
                                    subs: e.target.value.match(numberRegex),
                                    customSubs: true,
                                  });
                              }}
                            />
                          </div>
                          <div className="gift-subs-description">
                            <div className="gift-subs-icon-text bold">
                              Gift{" "}
                              <span className="red bold large-font">
                                {selectedPlan.subs}
                              </span>{" "}
                              Subs to the{" "}
                              <span className="red large-font">
                                {channelid}
                              </span>{" "}
                              community
                              <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                            </div>
                          </div>
                          <div className="gift-subs-price red">
                            <div className="gift-subs-icon-text-center bold">
                              ${selectedPlan.subs * 5}
                              <i className="fas fa-gifts mx-10 fa-lg red"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedPlan.price === 0 &&
                      selectedPlan.subs === 0 &&
                      !selectedPlan.customSubs && (
                        <div>
                          <div className="sub-section-container">
                            <div className="flex-only">
                              <i className="fas fa-gift mr-5 fa-lg mt-5 red"></i>
                              <p className="sub-section red">
                                Gift Custom number of Subs (Limit 100 max)
                              </p>
                            </div>
                          </div>
                          <div
                            className="gift-subs"
                            price={0}
                            subs={0}
                            onClick={(e) =>
                              setSelectedPlan({
                                price: e.currentTarget.attributes.price.value,
                                subs: e.currentTarget.attributes.subs.value,
                                customSubs: true,
                              })
                            }
                          >
                            <div className="gift-subs-count white bold">0</div>
                            <div className="gift-subs-description">
                              <div className="gift-subs-icon-text bold">
                                Gift{" "}
                                <span className="red bold large-font">0</span>{" "}
                                Subs to the{" "}
                                <span className="red large-font">
                                  {channelid}
                                </span>{" "}
                                community
                                <i className="fas fa-hand-holding-heart mx-10 fa-lg align-icon red"></i>
                              </div>
                            </div>
                            <div className="gift-subs-price red">
                              <div className="gift-subs-icon-text-center bold">
                                $0
                                <i className="fas fa-gifts mx-10 fa-lg red"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="sub-grid">
                      <div className="sub-section-container">
                        <div className="flex-only">
                          <i className="fas fa-star mr-5 fa-lg mt-5 red"></i>
                          <p className="sub-section red">Benefits</p>
                        </div>
                      </div>
                      <p className="sub-description">
                        As a subscriber, users are able to request Live Link
                        chats with the Mentor(s) to whom you are subscribed to,
                        along with access to their most recent course!
                      </p>
                    </div>
                    <div className="billing">
                      <div className="sub-section-container-subscription-alt">
                        <div className="flex-only">
                          <i className="fas fa-solid fa-money-check-dollar mr-5 fa-lg mt-5 red"></i>
                          <p className="sub-section red">Payment Methods</p>
                        </div>
                        <div className="flex-only">
                          <i className="fab fa-cc-visa mr-5 mt-5 fa-2x white"></i>
                          <i className="fab fa-cc-mastercard mr-5 mt-5 fa-2x white"></i>
                          <i className="fab fa-cc-jcb mr-5 mt-5 fa-2x white"></i>
                          <i className="fab fa-cc-discover mr-5 mt-5 fa-2x white"></i>
                          <i className="fab fa-cc-diners-club mr-5 mt-5 fa-2x white"></i>
                          <i className="fab fa-cc-amex mt-5 fa-2x white"></i>
                        </div>
                      </div>
                      <div className="sub-section-container-subscription">
                        <div className="flex-only">
                          <i className="fas fa-regular fa-credit-card mr-5 fa-lg mt-5 red"></i>
                          <p className="sub-section red">Card Information</p>
                        </div>
                      </div>
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          <label htmlFor="name" className="red bold block">
                            *Name on Card
                          </label>
                          {billingDetails.name === "" && <Alert />}
                          <Field
                            name="name"
                            id="name"
                            type="text"
                            placeholder="Enter Name on Card"
                            required
                            autoComplete="name"
                            value={billingDetails.name}
                            onChange={(e) => {
                              setBillingDetails({
                                ...billingDetails,
                                name: e.target.value,
                              });
                            }}
                          />
                        </div>
                        <div className="input-grid">
                          <label htmlFor="email" className="red bold block">
                            *Email Address
                          </label>
                          {billingDetails.email === "" && <Alert />}
                          <Field
                            name="email"
                            id="email"
                            type="email"
                            placeholder="Enter Email Address"
                            required
                            autoComplete="email"
                            value={billingDetails.email}
                            onChange={(e) => {
                              setBillingDetails({
                                ...billingDetails,
                                email: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="input-grid">
                          <label
                            htmlFor="cardnumber"
                            className="red bold block"
                          >
                            *Card Number
                          </label>
                          <CardField
                            onChange={(e) => {
                              setError(e.error);
                              setCardComplete(e.complete);
                            }}
                          />
                        </div>
                      </div>
                      <div className="sub-grid-two">
                        <div className="input-grid">
                          <label htmlFor="line1" className="red bold block">
                            *Billing Address Line 1
                          </label>
                          {billingDetails.address.line1 === "" && <Alert />}
                          <Field
                            name="line1"
                            id="line1"
                            type="text"
                            placeholder="Enter Street Address"
                            required
                            autoComplete="line1"
                            value={billingDetails.address.line1}
                            onChange={(e) => {
                              const billingdetails = { ...billingDetails };
                              billingdetails.address.line1 = e.target.value;
                              setBillingDetails(billingdetails);
                            }}
                          />
                        </div>
                        <div className="input-grid">
                          <label htmlFor="line2" className="red bold block">
                            Billing Address Line 2
                          </label>
                          <Field
                            name="line2"
                            id="line2"
                            type="text"
                            placeholder="Enter Suite, Apt, Unit"
                            autoComplete="line2"
                            value={billingDetails.address.line2}
                            onChange={(e) => {
                              const billingdetails = { ...billingDetails };
                              billingdetails.address.line2 = e.target.value;
                              setBillingDetails(billingdetails);
                            }}
                          />
                        </div>
                      </div>
                      <div className="sub-grid-three-alt-subscribe">
                        <div className="input-grid">
                          <label htmlFor="country" className="red bold block">
                            *Country
                          </label>
                          {billingDetails.address.country === "" && <Alert />}
                          <select
                            name="country"
                            id="country"
                            type="country"
                            required
                            value={billingDetails.address.country}
                            onChange={(e) => {
                              const billingdetails = { ...billingDetails };
                              billingdetails.address.country = e.target.value;
                              setBillingDetails(billingdetails);
                            }}
                          >
                            <option value="US">US</option>
                            <option value="AU">AU</option>
                            <option value="AT">AT</option>
                            <option value="BE">BE</option>
                            <option value="BR">BR</option>
                            <option value="BG">BG</option>
                            <option value="CA">CA</option>
                            <option value="CY">CY</option>
                            <option value="CZ">CZ</option>
                            <option value="DK">DK</option>
                            <option value="EE">EE</option>
                            <option value="FI">FI</option>
                            <option value="FR">FR</option>
                            <option value="DE">DE</option>
                            <option value="GR">GR</option>
                            <option value="HK">HK</option>
                            <option value="HU">HU</option>
                            <option value="IN">IN</option>
                            <option value="IE">IE</option>
                            <option value="IT">IT</option>
                            <option value="JP">JP</option>
                            <option value="LV">LV</option>
                            <option value="LT">LT</option>
                            <option value="LU">LU</option>
                            <option value="MY">MY</option>
                            <option value="MT">MT</option>
                            <option value="MX">MX</option>
                            <option value="NL">NL</option>
                            <option value="NZ">NZ</option>
                            <option value="NO">NO</option>
                            <option value="PL">PL</option>
                            <option value="PT">PT</option>
                            <option value="RO">RO</option>
                            <option value="SG">SG</option>
                            <option value="SK">SK</option>
                            <option value="SI">SI</option>
                            <option value="ES">ES</option>
                            <option value="SE">SE</option>
                            <option value="CH">CH</option>
                            <option value="AE">AE</option>
                            <option value="GB">GB</option>
                          </select>
                        </div>
                        {billingDetails.address.country === "US" && (
                          <div className="input-grid">
                            <label htmlFor="state" className="red bold block">
                              *State
                            </label>
                            {billingDetails.address.state === "" && <Alert />}
                            <select
                              name="state"
                              id="state"
                              type="state"
                              required
                              value={billingDetails.address.state}
                              onChange={(e) => {
                                const billingdetails = { ...billingDetails };
                                billingdetails.address.state = e.target.value;
                                setBillingDetails(billingdetails);
                              }}
                            >
                              <option value="Alabama">Alabama</option>
                              <option value="Alaska">Alaska</option>
                              <option value="Arizona">Arizona</option>
                              <option value="Arkansas">Arkansas</option>
                              <option value="California">California</option>
                              <option value="Colorado">Colorado</option>
                              <option value="Connecticut">Connecticut</option>
                              <option value="Delaware">Delaware</option>
                              <option value="Florida">Florida</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Idaho">Idaho</option>
                              <option value="Illinois">Illinois</option>
                              <option value="Indiana">Indiana</option>
                              <option value="Iowa">Iowa</option>
                              <option value="Kansas">Kansas</option>
                              <option value="Kentucky">Kentucky</option>
                              <option value="Louisiana">Louisiana</option>
                              <option value="Maine">Maine</option>
                              <option value="Maryland">Maryland</option>
                              <option value="Massachusetts">
                                Massachusetts
                              </option>
                              <option value="Michigan">Michigan</option>
                              <option value="Minnesota">Minnesota</option>
                              <option value="Mississippi">Mississippi</option>
                              <option value="Missouri">Missouri</option>
                              <option value="Montana">Montana</option>
                              <option value="Nebraska">Nebraska</option>
                              <option value="Nevada">Nevada</option>
                              <option value="New Hampshire">
                                New Hampshire
                              </option>
                              <option value="New Jersey">New Jersey</option>
                              <option value="New Mexico">New Mexico</option>
                              <option value="New York">New York</option>
                              <option value="North Carolina">
                                North Carolina
                              </option>
                              <option value="North Dakota">North Dakota</option>
                              <option value="Ohio">Ohio</option>
                              <option value="Oklahoma">Oklahoma</option>
                              <option value="Oregon">Oregon</option>
                              <option value="Pennsylvania">Pennsylvania</option>
                              <option value="Rhode Island">Rhode Island</option>
                              <option value="South Carolina">
                                South Carolina
                              </option>
                              <option value="South Dakota">South Dakota</option>
                              <option value="Tennessee">Tennessee</option>
                              <option value="Texas">Texas</option>
                              <option value="Utah">Utah</option>
                              <option value="Vermont">Vermont</option>
                              <option value="Virginia">Virginia</option>
                              <option value="Washington">Washington</option>
                              <option value="West Virginia">
                                West Virginia
                              </option>
                              <option value="Wisconsin">Wisconsin</option>
                              <option value="Wyoming">Wyoming</option>
                            </select>
                          </div>
                        )}
                        {billingDetails.address.country !== "US" && (
                          <div className="input-grid">
                            <label htmlFor="state" className="red bold block">
                              *State
                            </label>
                            {billingDetails.address.state === "" && <Alert />}
                            <Field
                              name="state"
                              id="state"
                              type="state"
                              placeholder="Enter State"
                              required
                              autoComplete="state"
                              value={billingDetails.address.state}
                              onChange={(e) => {
                                setBillingDetails({
                                  ...billingDetails,
                                  address: { state: e.target.value },
                                });
                              }}
                            />
                          </div>
                        )}
                        <div className="input-grid">
                          <label htmlFor="city" className="red bold block">
                            *City
                          </label>
                          {billingDetails.address.city === "" && <Alert />}
                          <Field
                            name="city"
                            id="city"
                            type="text"
                            placeholder="Enter City"
                            autoComplete="city"
                            required
                            value={billingDetails.address.city}
                            onChange={(e) => {
                              const billingdetails = { ...billingDetails };
                              billingdetails.address.city = e.target.value;
                              setBillingDetails(billingdetails);
                            }}
                          />
                        </div>
                      </div>
                      <div className="checkboxes">
                        <input
                          className="mx-5 checkbox"
                          type="checkbox"
                          checked={isGiftAnon}
                          onChange={(e) => setGiftAnon(e.target.checked)}
                        ></input>
                        <span className="red bold mx-5">Gift Anonymously</span>
                      </div>
                      {error && <ErrorMessage>{error.message}</ErrorMessage>}
                      <SubmitButton
                        processing={processing}
                        error={error}
                        disabled={!stripe}
                        onSubmit={(e) => handleSubmit(e)}
                      >
                        <i className="fas fa-gifts mr-5"></i>Confirm and Gift
                        Subscriptions
                      </SubmitButton>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    </Fragment>
  );
};

GiftCommunitySubscriptions.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(GiftCommunitySubscriptions);
